<template>
  <v-app>
    <v-main>
      <v-container 
        fluid 
        class="d-flex align-center justify-center"
        style="height: 100vh; position: relative; overflow: hidden;"
      >
        <!-- Fondo animado Lottie -->
        <div 
          ref="lottieContainer"
          class="position-absolute lottie-background"
          style="
            width: 100vw; 
            height: 100vh; 
            top: 0; 
            left: 0; 
            z-index: 0;
          "
        ></div>

        <!-- Centrado del formulario -->
        <v-row class="d-flex justify-center align-center" style="height: 100vh;">
          <v-col cols="12" sm="6" md="5" class="d-flex justify-center">
            <v-card 
              class="pa-8"
              style="
                width: 100%;
                max-width: 400px;
                min-height: 550px;
                box-shadow: none; 
                z-index: 1;
              "
            >
              <!-- <v-img
                :src="require('../assets/logo-viscosim.png')" 
                alt="Logo"
                max-width="300"
                class="mx-auto"
              ></v-img> -->
              <div class="titulo" >
                {{$t('login.titulo')}}
              <span class="subtitle gris_medio subitulo2 " >By  
               <!-- <img 
                class="ml-1 mr-1"
                  :src="require('../assets/simulart.svg')"
                  alt="Logo" 
                  style="height: 15px;color:black; vertical-align: middle;"  
                /> --> SimularT & Viscofan España
                
              </span>
              </div>
              <br>

              <v-card-subtitle class="text-center">{{$t('login.subtitulo')}}</v-card-subtitle>
              <v-form @submit.prevent="login" class="d-flex flex-column">
                <v-text-field
                  v-model="email"
                  :label="$t('login.usuario')"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="password"
                  :label="$t('login.password')"
                  :type="showPassword ? 'text' : 'password'"
                  required
                  append-icon="mdi-eye"
                  @click:append="togglePasswordVisibility"
                ></v-text-field>
                <v-btn color="primary" class="mt-4" type="submit">
                  {{$t('login.boton_entrar')}}
                </v-btn>
                
                <!-- Alineación de ComponenteIdioma e imagen en la misma línea -->
                <div class="d-flex align-center justify-space-between mt-4">
                  <ComponenteIdioma />
                  <v-img 
                    :src="require('../assets/simulart.svg')" 
                    alt="Logo" 
                    max-width="150"
                  ></v-img>
                </div>

              </v-form>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>



<script>
import { mapGetters } from 'vuex';
import ComponenteIdioma from './ComponenteIdioma.vue';
import axios from 'axios';
import lottie from "lottie-web";


export default {
  name: 'PaginaLogin',
  components: { ComponenteIdioma },
  data() {
    return { 
      email: '', 
      password: '', 
      showPassword: false };
  },
  computed: {
    ...mapGetters(['getMiVariableGlobal'])
  },
  mounted() {

    setTimeout(() => {
        this.loadLottie();
      }, 500); // Pequeño retraso para asegurar que el DOM esté listo


  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    login() {
      axios({
        method: 'get',
        url: process.env.VUE_APP_API_BASE_URL + '/api/login',
        auth: {
          username: this.email,
          password: encodeURIComponent(this.password),
        },
        headers: { 'Content-Type': 'application/json; charset=utf-8' },
      })
        .then((response) => {
          if (response.data.resultado !== 'ok') {
            this.$swal(response.data.resultado);
          } else {
            this.$store.dispatch('actualizarUsuarioAutenticado', true);
            this.$store.dispatch('actualizarToken', response.data.token);                 
            this.$store.dispatch('actualizarUsuarioNombre', this.email);

            this.$router.push('/');
          }
        });
    },


    loadLottie() {
        //alert("a")
        if (this.$refs.lottieContainer) {
          //alert("b")
          lottie.loadAnimation({
            container: this.$refs.lottieContainer,
            renderer: "svg",
            loop: true,
            autoplay: true,
            path: "/background.json", // Asegura que la ruta es correcta
          });
        } else {
          console.error("No se encontró el contenedor de Lottie.");
        }
      }



  },
};
</script>

<style>
.lottie-background {
  background-color:#006699; /* O usa una imagen de fondo */
}

.titulo{
  color:#0076A0 !important;
   text-decoration: none;
   font-size: 60px ; 
   text-align: center;
}
.subitulo2{
  text-align: center;
  display: flex;
  display: block;  
  font-size: 10px ;
}
</style>
